<ngx-spinner
    bdColor="rgba(51, 51, 51, 0.0)"
    size="large"
    color="#039be5"
    type="ball-clip-rotate"
></ngx-spinner>
<fuse-progress-bar></fuse-progress-bar>
<ng-container>
    <cage></cage>
</ng-container>
<simple-notifications [options]="options"></simple-notifications>
